import type { CurrenciesProvider } from '../apps/currencies/currencies/inversify.config'
import { convertMoneyCurrency, MoneyType } from '~/utility/money'

export function convertCurrency(
  priceToConvert: MoneyType,
  toCurrencyCode: string,
): Promise<MoneyType> {
  if (priceToConvert.getCurrency() === toCurrencyCode) {
    return Promise.resolve(priceToConvert)
  }
  return import(
    /* webpackChunkName: "currencies-inversify", webpackMode: "lazy" */ '../apps/currencies/currencies/inversify.config'
  ).then(async ({ currenciesContainer, ICurrenciesProvider }) => {
    const currencies = await currenciesContainer.get<CurrenciesProvider>(
      ICurrenciesProvider,
    )()
    const fromCurrency = currencies[priceToConvert.getCurrency()]
    const toCurrency = currencies[toCurrencyCode]
    return convertMoneyCurrency(priceToConvert, fromCurrency, toCurrency)
  })
}

export async function convertCurrencyAsPojo(
  priceToConvert: MoneyType,
  toCurrencyCode: string,
) {
  const converted = await convertCurrency(priceToConvert, toCurrencyCode)
  return converted.toObject()
}
